import { Rule, Tabs, TradeStatusAlert } from 'components/core-v2'
import { FC } from 'react'
import { useParams } from 'react-router-dom'

import { TradeTabs } from '../../components/trade-tabs'
import classes from './index.module.scss'

interface Props {
  tabValue: string
}
export const TradeTemplate: FC<Props> = ({ children, tabValue }) => {
  const { source, tradeId } = useParams()
  return (
    <>
      <div className={classes.tabWrapper}>
        <TradeTabs />
      </div>
      <Rule />
      <main className={classes.main}>
        <TradeStatusAlert className="mb-8" tradeId={tradeId} tradeSource={source} />
        <Tabs.Panel className="flex-1 flex flex-column" value={tabValue}>
          {children}
        </Tabs.Panel>
      </main>
    </>
  )
}
